import classNames from 'classnames'

import { commonIcons } from '@apps-common/config/icons'
import { UnitPlanUpgradeability } from '@apps-common/config/unit-plan'
import { IUnitPlanModel } from '@apps-common/types/portal/unit'

export const UnitActivationPlanCardSkeleton = () => (
  <div className='relative flex flex-col gap-[5px] min-w-[140px] min-h-[135px] border border-skeleton-border rounded-3xl text-[0.9em] px-3 py-3 text-left bg-skeleton animate-pulse'>
    <div className='h-[18px] rounded w-[60%] bg-skeleton-hi mb-[5px]' />
    <div className='flex items-center justify-start gap-[5px]'>
      <div className='h-[16px] grow rounded bg-skeleton-hi' />
      <div className='h-[16px] grow rounded bg-skeleton-hi' />
    </div>
    <div className='flex items-center justify-start gap-[5px]'>
      <div className='h-[16px] grow rounded bg-skeleton-hi' />
      <div className='h-[16px] grow rounded bg-skeleton-hi' />
    </div>
    <div className='flex items-center justify-start gap-[5px]'>
      <div className='h-[16px] grow rounded bg-skeleton-hi' />
      <div className='h-[16px] grow rounded bg-skeleton-hi' />
    </div>
    <div className='flex items-center justify-start gap-[5px]'>
      <div className='h-[16px] grow rounded bg-skeleton-hi' />
      <div className='h-[16px] grow rounded bg-skeleton-hi' />
    </div>
  </div>
)

interface IProps {
  data: IUnitPlanModel
  planId?: string
  upgradePath?: string
  onChange: (unitPlanId: string) => void
}

export const UnitActivationPlanCard: React.FC<IProps> = ({ data, planId, upgradePath, onChange }) => (
  <button
    type='button'
    className={classNames(
      'relative w-full min-w-[140px] border border-border rounded-3xl text-[0.9em] px-3 py-3 text-left',
      planId === data.unitPlanId && 'border-brand',
      planId !== data.unitPlanId && upgradePath === UnitPlanUpgradeability.fixed && 'opacity-30'
    )}
    disabled={upgradePath === UnitPlanUpgradeability.fixed}
    onClick={() => {
      if (upgradePath === UnitPlanUpgradeability.fixed) return

      onChange(data.unitPlanId)
    }}
  >
    {planId === data.unitPlanId && (
      <div className='absolute top-[-5px] right-[-5px] bg-surface rounded-full'>
        <commonIcons.checkCircle className='text-[1.85rem] text-brand' />
      </div>
    )}
    <div className='mb-[8px] jost text-[0.8rem]'>{data.unitPlanName}</div>
    <div className='flex flex-col gap-[3px] text-text'>
      {data?.planDescription?.split(',')?.map((d, di) => (
        <div key={`unit-plan-description-item-${data.unitPlanId}-${di}`} className='text-[0.85em] flex items-center justify-between'>
          {d?.split(':')?.map((dv, dvi) => (
            <div
              key={`unit-plan-description-item-${data.unitPlanId}-${di}-${dvi}`}
              className={classNames(dvi % 2 === 0 && 'jost-light bg-surface-2 rounded-[3px] px-[3px]')}
            >
              {dv}
            </div>
          ))}
        </div>
      ))}
    </div>
  </button>
)
